import {useCallback, useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {doesMatchEventCategory} from '~/common/utils/event_utils';
import {FUNERAL_CATEGORY} from '~/common/utils/event_constants';
import {selectClassifiedCategory} from '~/common/fabric/reducers/eviteEvent/selectors';
import {selectIsFuneral} from '~/ViewInvitation/selectors/eviteEvent';
import {
  animationLength,
  ConfettiAnimation,
} from '~/ViewInvitation/routes/Confirmation/ConfettiAnimation/ConfettiAnimation';

type SuccessRoktProps = {
  step: number;
  status: string;
};

export const Animation = ({status, step}: SuccessRoktProps) => {
  const isFuneralType = useSelector(selectIsFuneral);
  const classifiedCategory = useSelector(selectClassifiedCategory);
  const isFuneral = isFuneralType || doesMatchEventCategory(classifiedCategory, FUNERAL_CATEGORY);
  const [animationPlaying, setAnimationPlaying] = useState(false);
  const [animationPlayed, setAnimationPlayed] = useState(false);

  const triggerAnimation = useCallback(() => {
    if (isFuneral || animationPlayed || step !== 1) {
      return;
    }

    setAnimationPlaying(true);

    setTimeout(() => {
      setAnimationPlaying(false);
      setAnimationPlayed(true);
    }, animationLength);
  }, [isFuneral, animationPlayed, step]);

  useEffect(() => {
    if (status !== 'No') {
      triggerAnimation();
    }
  }, [triggerAnimation, status]);

  return animationPlaying && <ConfettiAnimation height="100%" width="100%" />;
};
